import { BehaviorSubject, from, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AngularFireMessaging } from '@angular/fire/compat/messaging';

import { NotificationMessage } from '@shared/models/Notification';
import { HttpHandlerService } from './http-handler.service';
import { ToastService } from './toast.service';
import { User } from '@shared/models/User';
import { environment } from '@env';

const OLD_BASE_URL = `${environment.oldMessagingBaseUrl}/api/v1/notifications/fcm`; // Subscribe
const NEW_BASE_URL = `${environment.messagingBaseUrl}/api/v1/notifications/fcm`; // Tudo que não for subscribe

@Injectable({ providedIn: 'root' })
export class MessagingService {

  public readonly APPLICATION_ID = 'ottimizzaoic';

  public currentMessage = new BehaviorSubject<any>(null);

  constructor(private afm: AngularFireMessaging, private http: HttpHandlerService, private toast: ToastService) {
    this.afm.messages.subscribe((messaging: any) => {
			messaging.onMessage = messaging.onMessage.bind(messaging);
			messaging.onTokenRefresh = messaging.onTokenRefresh.bind(messaging);
    });
  }

  private unsubscribe() {
    return this.afm.getToken
    .pipe(
      switchMap(token => this.afm.deleteToken(token)),
      switchMap(() => from(navigator.serviceWorker.getRegistration())),
      map((serviceWorkers: any) => {
        if (serviceWorkers.length) {
          for (const sw of serviceWorkers) {
            sw.unregister();
          }
        } else if ('unregister' in serviceWorkers) {
          serviceWorkers.unregister();
        }
      })
    );
  }

  public requestPermission() {
    this.toast.showSnack('Habilitando notificações...')
    return this.unsubscribe()
    .pipe(
      catchError(() => of(false)),
      switchMap(() => this.afm.requestToken),
      catchError(err => {
        console.error('Unable to get permission to notify', err);
        this.toast.show('Seu navegador não autorizou a exibição de notificações. Verifique se você concedeu permissão', 'warning')
        return throwError(err);
      }),
      switchMap(token => this.registerUser(token)),
      switchMap(() => this.sendTestNotification()),
      map(() => {
        this.toast.show('Notificações habilitadas com sucesso!', 'success');
        return;
      })
    );
  }

	public receiveMessage() {
		this.afm.messages.subscribe(payload => {
			console.log('new message received. ', payload);
			this.currentMessage.next(payload);
		});
	}

  public sendNotification(to: string, message: NotificationMessage) {
    if (!message.icon) {
      message.icon = 'https://ottimizza.com.br/wp-content/themes/ottimizza/images/logo.png'
    }
    const url = `${NEW_BASE_URL}`;
    const notification = {
      applicationId: this.APPLICATION_ID,
      username: to,
      notification: message,
    };
    return this.http.post(url, notification, 'Falha ao notificar usuário!');
  }

  private registerUser(firebaseToken: string) {
    const currentUser = User.fromLocalStorage();
    const url = `${OLD_BASE_URL}/subscribe`;
    const body = {
      username: currentUser.email || currentUser.username,
      registrationId: firebaseToken,
      applicationId: this.APPLICATION_ID,
    };
    return this.http.post(url, body, 'Falha ao registrar-se no serviço de notificações!', null, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  public sendTestNotification() {
    const currentUser = User.fromLocalStorage();
    const message: NotificationMessage = {
      title: 'Sucesso!',
      body: 'Notificações habilitadas com sucesso!'
    };
    return this.sendNotification(currentUser.email || currentUser.username, message);
  }

}
